/**
 * CSV import service
 */

import { supabase } from './supabase';

/**
 * CSV import service for bulk operations
 */
export const csvService = {
  /**
   * Imports validated bottles in bulk
   * @param {Array} bottles - Validated bottle data
   * @returns {Promise<{imported: number, errors: Array}>} Import results
   */
  async importBottles(bottles) {
    const { data: { user } } = await supabase.auth.getUser();

    const bottlesWithUser = bottles.map(bottle => ({
      ...bottle,
      user_id: user.id,
      created_by: user.id
    }));

    const errors = [];
    let imported = 0;

    for (let i = 0; i < bottlesWithUser.length; i += 50) {
      const batch = bottlesWithUser.slice(i, i + 50);
      const { error, data } = await supabase
        .from('bottles')
        .insert(batch)
        .select();

      if (error) {
        errors.push({
          batch: Math.floor(i / 50) + 1,
          message: error.message
        });
      } else {
        imported += data.length;
      }
    }

    return { imported, errors };
  },

  /**
   * Imports validated distilleries in bulk
   * @param {Array} distilleries - Validated distillery data
   * @returns {Promise<{imported: number, errors: Array}>} Import results
   */
  async importDistilleries(distilleries) {
    const { data: { user } } = await supabase.auth.getUser();

    const distilleriesWithUser = distilleries.map(distillery => ({
      ...distillery,
      user_id: user.id,
      created_by: user.id
    }));

    const errors = [];
    let imported = 0;

    for (let i = 0; i < distilleriesWithUser.length; i += 50) {
      const batch = distilleriesWithUser.slice(i, i + 50);
      const { error, data } = await supabase
        .from('distilleries')
        .insert(batch)
        .select();

      if (error) {
        errors.push({
          batch: Math.floor(i / 50) + 1,
          message: error.message
        });
      } else {
        imported += data.length;
      }
    }

    return { imported, errors };
  }
};
